import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './ActionBarIcon.scss';
var ActionBarIcon = function (_a) {
    var Icon = _a.icon, iconRef = _a.iconRef, isActive = _a.isActive, children = _a.children;
    var iconProps = {
        className: classnames(s['icon'], isActive && s['active']),
        customSizable: true,
        disableDefaultColors: true,
        containerRef: iconRef,
    };
    if (children) {
        return React.createElement(React.Fragment, null, children(iconProps));
    }
    if (Icon) {
        return React.createElement(Icon, __assign({}, iconProps));
    }
    return null;
};
ActionBarIcon.displayName = 'ActionBarIcon';
export default ActionBarIcon;
//# sourceMappingURL=ActionBarIcon.js.map